var map;
var initialZoom = 7;
var securityExpertZoom = 11;
var allSecurityExperts;
var centerMap = { lat: 50.4167, lng: 4.4333 };
var homeMarker;
var securityExpertTemplate = '<div class="security-expert-selector" security-expert-id={id}><h5><b>{name}</b></h5><p>{address1}</p><p>{address2}</p><a class="main-cta" href="/expert/{language}/{url}">{more-info} <span class="arrow black"></span><span class="arrow blue"></span></a></div>'
var securityExpertMarkers = [];
var searchTimeout = 800;
var resultsCount = 10;
var geocoder;
var bounds;
var selectedSecurityExpert;
var maxDistance = 200;
var homeLocationLat = 50.85045;
var homeLocationLon = 4.34878;

function init() {
	if($("#map").length > 0){
		map = new google.maps.Map(document.getElementById('map'), {
			zoom: initialZoom,
			center: centerMap
		});

		geocoder = new google.maps.Geocoder()
		
		if(localStorage.getItem('userLocation') != null){
			geocoder.geocode({ 'address': localStorage.getItem('userLocation') }, function (results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					var latitude = results[0].geometry.location.lat();
					var longitude = results[0].geometry.location.lng();
					
					addHomeMarker(longitude, latitude);
					setAllSecurityExperts();
					bindSearch();
				}
			});
		}else{
			storeUserLocation("Brussels, Belgium");
			addHomeMarker(homeLocationLon, homeLocationLat);
			
			setAllSecurityExperts();
			bindSearch();
		}		
	}
}

function centerMapBasedOnMarkers(){
	bounds = new google.maps.LatLngBounds();
	bounds.extend(new google.maps.LatLng(homeMarker.position.lat(), homeMarker.position.lng()));
	
	for(var i = 0; i < securityExpertMarkers.length; i++){
		bounds.extend(new google.maps.LatLng(securityExpertMarkers[i].position.lat(), securityExpertMarkers[i].position.lng()));
	}
	
	map.fitBounds(bounds); 
	map.panToBounds(bounds); 
	
	stopLoading();
}

function addHomeMarker(lng, lat){		
	if(homeMarker != undefined){
		homeMarker.setMap(null);
	}
	
	homeMarker = addMarkerToMap(lng, lat, true);
	homeMarker.addListener('dragend', homeMarkerDragEnd);
}

function homeMarkerDragEnd(event) {
	var country = "";
	var city = "";
	var street = "";
	var number = "";
	
	geocoder.geocode({'latLng': event.latLng}, function(results, status) 
      {
        if (status == google.maps.GeocoderStatus.OK) 
        {
			var bestResult = results[0].address_components;

			for(var i = 0; i < bestResult.length; i++){
				if(bestResult[i].types[0] == "locality"){
					city = bestResult[i].long_name
				}else if(bestResult[i].types[0] == "country"){
					country = bestResult[i].long_name
				}else if(bestResult[i].types[0] == "route"){
					street = bestResult[i].long_name
				}else if(bestResult[i].types[0] == "street_number"){
					number = bestResult[i].long_name
				}
			}
			
			$(".locator-search-input").val(city+", "+country);
			
			storeUserLocation(street + " " + number + ", "+ city + ", " + country);
			
			searchSecurityExperts(country, city, "");
        }
	});	
}

function setAllSecurityExperts(){
	var url = "/locator/all/";
	
	if($("#map[campaign-experts-only=true]").length > 0){
		url = "/locator/allcampaign/";
	}
	
	$.ajax({
	   type: "GET",
	   url: url,
	   success: function(data)
	   {
		   allSecurityExperts = data.data;
		   addSecurityExpertMarkers(allSecurityExperts);
		   addSecurityExpertsInfo(allSecurityExperts);
		   $(".locator-search-icon").trigger("click");
	   }
	 });
}

function bindSearch(){
	var searchDelayTimer;

	$(".locator-search-input").unbind("keyup");
	$(".locator-search-input").bind("keyup",function(){
		var searchValue = $(this).val();
		clearTimeout(searchDelayTimer);
		
		searchDelayTimer = setTimeout(function() {
			searchSecurityExperts("", "", searchValue)	
		}, searchTimeout);
	});
	
	$(".locator-search-icon").unbind("click");
	$(".locator-search-icon").bind("click",function(){
		var searchValue = $(".locator-search-input").val();
		searchSecurityExperts("", "", searchValue)	
	});
	
	$(".locator-remove-icon").unbind("click");
	$(".locator-remove-icon").bind("click",function(){
		$(".locator-search-input").val("");
		searchSecurityExperts("", "", "")	
	});
}

function addSecurityExpertMarkers(securityExperts){
	for(var i = 0; i < securityExpertMarkers.length; i++){
		securityExpertMarkers[i].setMap(null);
	}
	
	securityExpertMarkers = [];
	
	for(var i = 0; i < securityExperts.length; i ++){		
		var marker = addMarkerToMap(securityExperts[i].Longitude, securityExperts[i].Latitude, false);
		marker.id = securityExperts[i]._id;

		securityExpertMarkers[securityExpertMarkers.length] = marker;
		
		marker.addListener('click', function(e) {
		  selectSecurityExpert(this.id)
		});
	}
}

function addMarkerToMap(longitude, latitude, draggable){
	var icon = "";
	
	if(draggable){		
		icon = {
			url: "/images/house-marker.png", 
			scaledSize: new google.maps.Size(24, 35)
		};
	}else{
		icon = {
			url: "/images/security-expert-marker.png", 
			scaledSize: new google.maps.Size(24, 35)
		};
	}
	
	var marker = new google.maps.Marker({
		position:  { lat:parseFloat(latitude), lng: parseFloat(longitude) },
		map: map,
		draggable: draggable,
		icon: icon
	});	
	
	return marker;
}

function addSecurityExpertsInfo(securityExperts){	
	setSelectedSecurityExpert(null);
	
	$(".security-experts-container").html("");
	
	for(var i = 0; i < securityExperts.length; i ++){		
		var securityExpertSelector = securityExpertTemplate
			.replace("{name}", securityExperts[i].Name)
			.replace("{address1}", securityExperts[i].Address)
			.replace("{address2}", securityExperts[i].Zip + " " + securityExperts[i].City)
			.replace("{id}", securityExperts[i]._id)
			.replace("{url}", securityExperts[i].Url)
			.replace("{more-info}", $("#more-info-label").val())
			.replace("{language}", $("#language").val());
			
		$(".security-experts-container").append(securityExpertSelector);
	}
	
	$(".security-expert-selector").unbind("click");
	$(".security-expert-selector").bind("click",function() {
		selectSecurityExpert($(this).attr("security-expert-id"));
	});
	
	addSecurityExpertMarkers(securityExperts);
	centerMapBasedOnMarkers();
	
	$('.security-experts-container').animate({
		scrollTop: 0
	 }, 400);
}

function searchSecurityExperts(country , city, searchValue){
		startLoading();
		
		if(searchValue != ""){
			var expertsFoundByName = allSecurityExperts.filter(se => se.Name.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0);

			if(expertsFoundByName.length > 0){
				addSecurityExpertsInfo(expertsFoundByName);
			}else{
				if(!isNaN(searchValue)){
					searchValue += ", Belgium";
				}

				geocoder.geocode({ 'address': searchValue }, function (results, status) {
					if (status == google.maps.GeocoderStatus.OK) {
						var latitude = results[0].geometry.location.lat();
						var longitude = results[0].geometry.location.lng();
						
						if(getDistanceFromLatLonInKm(latitude,longitude,homeLocationLat,homeLocationLon) > 200){
							stopLoading();
						}else{
							addHomeMarker(longitude, latitude);
							addSecurityExpertsInfo(getClosestSecurityExperts(homeMarker.getPosition().lat(),homeMarker.getPosition().lng()));
							
							storeUserLocation(searchValue);
						}
					}else{
						stopLoading();
					}
				});
			}
		}else if(country != "" || city != ""){			
			addSecurityExpertsInfo(getClosestSecurityExperts(homeMarker.getPosition().lat(),homeMarker.getPosition().lng()));
		}else{
			addSecurityExpertsInfo(allSecurityExperts);
		}		
}

function getClosestSecurityExperts(lat, lng){
	for(var i = 0; i < allSecurityExperts.length; i++){
		var distance = getDistanceFromLatLonInKm(
			lat,
			lng,
			parseFloat(allSecurityExperts[i].Latitude),
			parseFloat(allSecurityExperts[i].Longitude)
		);
		
		allSecurityExperts[i].Distance = distance;
	}
	
	return allSecurityExperts.sort(function(a,b) { return a.Distance - b.Distance }).slice(0,resultsCount);
}

function selectSecurityExpert(id){	
	setSelectedSecurityExpert(allSecurityExperts.find(se => se._id === id));
	var selectedMarker = securityExpertMarkers.find(ma => ma.id === id);
	
	//reset and change marker icon
	for(var i = 0;i < securityExpertMarkers.length; i++){
		securityExpertMarkers[i].setIcon({url:'/images/security-expert-marker.png', scaledSize: new google.maps.Size(24, 35)});
	}
	selectedMarker.setIcon({url:'/images/security-expert-marker-black.png', scaledSize: new google.maps.Size(24, 35)});
	
	map.setZoom(securityExpertZoom);
	map.panTo(selectedMarker.position);
		
	$(".security-expert-selector").removeClass("selected");
	
	var securityExpertElement = $(".security-expert-selector[security-expert-id="+id+"]");
	securityExpertElement.addClass("selected");
	
	var scrollContainer = $(".security-expert-selector[security-expert-id="+id+"]").parent();
	
	$('.security-experts-container').animate({
		scrollTop: scrollContainer.scrollTop() + (securityExpertElement.offset().top - scrollContainer.offset().top)
	 }, 800);
}

function setSelectedSecurityExpert(expert){
	selectedSecurityExpert = expert;
	
	if(expert == null || expert == undefined){
		$(".btn-step-1").prop("disabled",true);
		$(".selected-security-expert-label").find("b:first").html("");
		$("#selected-expert-id").val("");
	}else{
		$(".btn-step-1").prop("disabled",false);
		$(".selected-security-expert-label").find("b:first").html(expert.Name);
		$("#selected-expert-id").val(expert._id);
	}
}

function startLoading(){
	$(".security-experts-container").addClass("loading");
	$(".locator-search-icon").addClass("loading");
}

function stopLoading(){
	$(".security-experts-container").removeClass("loading");
	$(".locator-search-icon").removeClass("loading");
	
	if($(".locator-search-input").val() == ""){
		$(".locator-search-icon").removeClass("hide");
		$(".locator-remove-icon").addClass("hide");
	}else{
		$(".locator-search-icon").addClass("hide");
		$(".locator-remove-icon").removeClass("hide");
	}
}

function getDistanceFromLatLonInKm(lat1,lng1,lat2,lng2) {
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2-lat1);  // deg2rad below
  var dLon = deg2rad(lng2-lng1); 
  var a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2)
    ; 
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  var d = R * c; // Distance in km
  return d;
}

function storeUserLocation(location){
	if(localStorage.getItem('cookiesAccepted') != null){
		localStorage.setItem('userLocation', location);
	}
}

function deg2rad(deg) {
  return deg * (Math.PI/180)
}

module.exports = {
	init : init
}